exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-icon {\n  max-width: 45px;\n  max-height: 45px;\n  border-radius: 10px;\n}\n.users td {\n  vertical-align: middle;\n  font-size: 1.2em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/user-manager/user-manager.component.less
// module id = ./src/app/admin/user-manager/user-manager.component.less
// module chunks = 0